<template>
  <label
    v-if="matchedAnswer(clientId.id).file_url === undefined"
    for="input-Upload"
    class="fas fa-cloud-upload-alt"
    style="font-size: 20px;"
  >
    <input
      type="file"
      @change="uploadFileImage('pre_dep', $event, clientId.id)"
      style="display:none"
      id="input-Upload"
    />
  </label>

  <img
    v-else
    width="21"
    src="/img/icons/correct.svg"
    style="cursor: pointer"
    @click="openDocInNewWindow(matchedAnswer(deposit.id).file_url)"
  />
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import BtnBar from "../misc/ConfirmIconButtons.component";

import apiClientCreator from "../../../../../../helpers/api/request";
// import Loader from "../../../../../../main/misc.main/loader/Loader";

export default {
  name: "PreDepositFileUpload.component",
  components: {
    // Loader,
    // BtnBar
  },
  props: {
    client: {
      ///answer
      type: Object,
      required: true
    },
    questionId: {
      type: Number,
      required: true
    },
    clientId: {
      type: Number,
      required: true
    },
    sendUpdated: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapState("clients", ["dictionaries"])
  },
  data() {
    return {
      showPopup: false,
      matchedAns: {},
      showDropDown: false,
      answerQuery: "",
      answerResults: [],
      answeringBusy: false,
      showSpinner: false,
      selectedAddAnswer: null,
      selectedUpdateAnswer: null,
      depAnswersAll: [],
      showTrueMenu: false
    };
  },
  watch: {
    depAnswersAll: function() {
      //localStorage.setItem('depositAnswers',JSON.stringify(this.depAnswersAll));
    }
  },
  created() {
    if (!localStorage.getItem("depositAnswers")) {
      localStorage.setItem(
        "depositAnswers",
        JSON.stringify(this.depAnswersAll)
      );
    } else {
      this.depAnswersAll = JSON.parse(localStorage.getItem("depositAnswers"));
    }
  },

  methods: {
    hasClient(clientId) {
      this.depAnswersAll = JSON.parse(localStorage.getItem("depositAnswers"));
      if (this.depAnswersAll.length > 0) {
        let idx = this.depAnswersAll.findIndex(id => id.client_id === clientId);
        if (idx > -1) {
          let findQuestionId = this.depAnswersAll[idx];
          return true;
        } else {
          return false;
        }
      }
    },
    async uploadFileImage(id, e, clientId) {
      this.showSpinner = true;
      this.forChoose = false;

      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);

      const formData = new FormData();
      formData.append("con_file", image);
      const apiClient = apiClientCreator(
        `client/support/deposit/answer/upload/${id}`
      );
      await apiClient.post("", formData).then(res => {
        this.depAnswersAll = JSON.parse(localStorage.getItem("depositAnswers"));
        let idx = this.depAnswersAll.findIndex(id => id.client_id === clientId);

        if (idx > -1) {
          this.depAnswersAll[idx].file_url = res.data;
        } else {
          let tempClient = {
            client_id: clientId,
            file_url: res.data,
            questions: []
          };
          this.depAnswersAll.push(tempClient);
        }

        localStorage.setItem(
          "depositAnswers",
          JSON.stringify(this.depAnswersAll)
        );
        this.$emit("updated");
        this.updateIcon = true;
      });
      this.forChoose = false;
      this.showSpinner = false;
    },
    openDocInNewWindow(url) {
      window.open(url, "_blank");
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY ");
    },
    checkEmpty() {
      /*onsole.log(this.client.find(
                        answer =>  answer.deposit_id ===  this.depositId).answer_confirm)*/

      let tt = null;
      tt = this.client.find(answer => answer.question_id === this.questionId);

      if (tt === null) {
        return true;
      } else {
        return false;
      }
    },

    matchedAnswer(clientId) {
      let findQuestionId = [];
      if (localStorage.getItem("depositAnswers")) {
        this.depAnswersAll = JSON.parse(localStorage.getItem("depositAnswers"));
      }
      if (this.depAnswersAll.length > 0) {
        let idx = this.depAnswersAll.findIndex(id => id.client_id === clientId);
        if (idx > -1) {
          findQuestionId = this.depAnswersAll[idx];
        }
      }
      return findQuestionId;
    },

    setAnswer(clientId, questionId, answer) {
      this.depAnswersAll = JSON.parse(localStorage.getItem("depositAnswers"));
      let idx = this.depAnswersAll.findIndex(id => id.client_id === clientId);

      if (idx > -1) {
        let qidx = this.depAnswersAll[idx].questions.findIndex(
          qid => qid.question_id === questionId
        );
        if (qidx > -1) {
          this.depAnswersAll[idx].questions[qidx].answer = answer;
        } else {
          let tempNeqQuest = {
            question_id: questionId,
            answer: answer
          };
          this.depAnswersAll[idx].questions.push(tempNeqQuest);
        }
      } else {
        this.depAnswersAll.push({
          client_id: clientId,
          questions: [
            {
              question_id: questionId,
              answer: answer
            }
          ]
        });
      }

      localStorage.setItem(
        "depositAnswers",
        JSON.stringify(this.depAnswersAll)
      );

      this.$emit("updated");
    },

    async updateAnswer(clientId, questionId, answer) {
      //this.showSpinner = true;
      this.depAnswersAll = JSON.parse(localStorage.getItem("depositAnswers"));

      let idx = this.depAnswersAll.findIndex(id => id.client_id === clientId);

      if (this.depAnswersAll.length > 0) {
        if (idx > -1) {
          let findQuestionIdx = this.depAnswersAll[idx].questions.findIndex(
            qid => qid.question_id === questionId
          );
          if (findQuestionIdx > -1) {
            this.depAnswersAll[idx].questions[findQuestionIdx].answer = answer;
          }
        }
      }
      //this.$emit("updated");
      localStorage.setItem(
        "depositAnswers",
        JSON.stringify(this.depAnswersAll)
      );
    }
  }
};
</script>

<style scoped>
.answer {
  cursor: pointer;
}

/*.answer-wrapper {
      display: inline;
      position: relative;
      text-align: center;
    }*/
.answer-wrapper {
  text-align: center;
}

.floating-wrapper-answers {
  position: relative;
}

.answer-table {
  position: absolute;
  bottom: 0px;
  right: 0px;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.table-responsive {
  margin-bottom: -20px;
  border-radius: 5px;
}

.td-answer {
  font-weight: 600;
}

.answers-dropdown {
  width: max-content;
}

.answers-dropdown-menu {
  border: solid 1px #90a4ae;
  border-radius: 0;
  left: 0;
  position: absolute;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.dropdown-menu {
  padding: 5px;
  height: auto;
  max-height: 200px;
  min-width: min-content;
  overflow-x: hidden;
}

.answer-menu-item {
  margin: 5px;
  font-size: 9pt;
  font-family: "Montserrat", Montserrat, serif;
}

.answer-menu-item:hover {
  background: #e0e0e0;
  cursor: pointer;
}

.answer-text {
  cursor: pointer;
}

.input-standard {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  box-sizing: border-box;
}

.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}

.spinner-answer {
  float: right;
  margin-top: 3px;
}
</style>
